// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kooltip.k-popover{--KPopColor:var(--KoolTipColor,var(--white,color(#fff)));--KPopBackground:var(--KoolTipBackground,var(--black-400,color(black-400)));--KPopBodySize:var(--type-sm);--KPopPaddingX:var(--spacing-xs);--KPopPaddingY:var(--spacing-xs);--KPopBorder:none;pointer-events:none;z-index:9999}", ""]);
// Exports
module.exports = exports;
